module.exports = __webpack_public_path__ + "static/ase-6ff7993d931e4e83485e4d3c55d6ebce.jpg";